/**
 * @generated SignedSource<<1b956e17d4043cf15979a631c8de1fe6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PaginationPagination$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Pagination">;
  readonly " $fragmentType": "PaginationPagination";
};
export type PaginationPagination$key = {
  readonly " $data"?: PaginationPagination$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaginationPagination">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PaginationPagination",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Pagination"
    }
  ],
  "type": "JiraProjectConnection"
};

(node as any).hash = "25025e1f4ecb1d0a3545492c6d05cd04";

export default node;
